import React, { useRef } from 'react';
import { useSpecSettings } from '../../contexts/SpecSettingsContext';
import { useMotionPreference } from '../../hooks/useMotionPreference';
import { useAvatarRenderer } from '../../hooks/useAvatarRenderer';
import { avatarStates } from '../../data/avatarStates';
import type { AvatarState, AvatarThread } from '../../types/anna';
interface AnnaAvatarProps {
  state: AvatarState;
  threads?: AvatarThread[];
  /** Increment to play one proactive wave */
  pulseKey?: number;
  className?: string;
}
const NO_THREADS: AvatarThread[] = [];

/** Anna's living presence. Fills its (square) parent. */
export function AnnaAvatar({
  state,
  threads = NO_THREADS,
  pulseKey = 0,
  className = ''
}: AnnaAvatarProps) {
  const {
    accentHex,
    aliveness
  } = useSpecSettings();
  const reduced = useMotionPreference();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useAvatarRenderer(canvasRef, {
    state,
    accent: accentHex,
    threads,
    reduced,
    pulseKey,
    aliveness
  });
  const label = avatarStates.find(s => s.id === state)?.label ?? state;
  return <canvas ref={canvasRef} role="img" aria-label={`Anna, toestand: ${label}`} className={`block h-full w-full ${className}`} data-id="element-19" data-mp="b04rvivzdthy" />;
}